import { store } from "../../redux/store";
import { loginOwner } from "../../redux/ownerSlice";
import { apiPost } from "../api";
import { getdeviceId } from "../auth";

/**
 * تقوم بطلب accessToken جديد باستخدام refreshToken
 * @returns accessToken الجديد أو null إذا فشل
 */
export const refreshAccessTokenOwner = async (): Promise<string | null> => {
  const state = store.getState();
  const refreshToken = state.owner.refreshToken;
  const deviceId = getdeviceId();

  if (!refreshToken) return null;

  try {
    // استدعاء API لتحديث accessToken
    const response = (await apiPost("owner/refresh-token", {
      refreshToken,
      deviceId,
    })) as { accessToken: string; refreshToken: string };

    // حفظ accessToken الجديد في Redux
    store.dispatch(
      loginOwner({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
      })
    );

    return response.accessToken;
  } catch (err) {
    console.error("Failed to refresh access token", err);
    // store.dispatch(logoutOwner()); // إذا انتهت صلاحية refreshToken → logout
    return null;
  }
};
